import React, { useState, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Card, Form, Button, Modal, Badge } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";

export default function GastosConfiguracionPage() {
    const { t } = useContext(TranslatorContext);
    
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(''); // 'categoria' o 'subcategoria'
    const [selectedCategoria, setSelectedCategoria] = useState('');
    const [formData, setFormData] = useState({
        nombre: '',
        descripcion: '',
        color: '#000000',
        activo: true
    });

    // Configuración de categorías y subcategorías
    const [categorias, setCategorias] = useState([
        {
            id: 1,
            nombre: 'Gastos Oficina',
            descripcion: 'Gastos operativos de la oficina principal',
            color: '#dc3545',
            activo: true,
            subcategorias: [
                { id: 1, nombre: 'Arriendo', activo: true },
                { id: 2, nombre: 'Luz', activo: true },
                { id: 3, nombre: 'Agua', activo: true },
                { id: 4, nombre: 'Gasto Común', activo: true },
                { id: 5, nombre: 'Plan Internet/Teléfono', activo: true },
                { id: 6, nombre: 'Sueldo Maxi', activo: true },
                { id: 7, nombre: 'Sueldo Laura', activo: true },
                { id: 8, nombre: 'Sueldo Alexa', activo: true },
                { id: 9, nombre: 'Sueldo Part Time', activo: true },
                { id: 10, nombre: 'Sueldo Contador', activo: true },
                { id: 11, nombre: 'PREVIRED', activo: true },
                { id: 12, nombre: 'IVA', activo: true },
                { id: 13, nombre: 'VISA', activo: true },
                { id: 14, nombre: 'Crédito 2', activo: true },
                { id: 15, nombre: 'Crédito 3', activo: true },
                { id: 16, nombre: 'Zoom', activo: true },
                { id: 17, nombre: 'Canva', activo: true },
                { id: 18, nombre: 'Mantención Plan', activo: true },
                { id: 19, nombre: 'Seguro vehículo', activo: true }
            ]
        },
        {
            id: 2,
            nombre: 'Edmundo Neira',
            descripcion: 'Gastos relacionados con Edmundo Neira',
            color: '#0dcaf0',
            activo: true,
            subcategorias: [
                { id: 20, nombre: 'Dividendo', activo: true },
                { id: 21, nombre: 'Luz', activo: true },
                { id: 22, nombre: 'Agua', activo: true },
                { id: 23, nombre: 'Gasto Común', activo: true },
                { id: 24, nombre: 'Internet', activo: true },
                { id: 25, nombre: 'Sueldo', activo: true }
            ]
        },
        {
            id: 3,
            nombre: 'Operativa/Terreno',
            descripcion: 'Gastos operacionales y de terreno',
            color: '#198754',
            activo: true,
            subcategorias: [
                { id: 26, nombre: 'Transporte', activo: true },
                { id: 27, nombre: 'Alimentación', activo: true },
                { id: 28, nombre: 'Estadía', activo: true },
                { id: 29, nombre: 'Sueldo', activo: true }
            ]
        },
        {
            id: 4,
            nombre: 'Egresos Operativos Temporada 24',
            descripcion: 'Egresos específicos de la temporada 2024',
            color: '#ffc107',
            activo: true,
            subcategorias: [
                { id: 30, nombre: 'Fondo Resolutivo/Emergencias', activo: true },
                { id: 31, nombre: 'Sueldo Coordinadores Generales', activo: true },
                { id: 32, nombre: 'Sueldo Coordinadores', activo: true },
                { id: 33, nombre: 'Combustible Temporada', activo: true }
            ]
        }
    ]);

    // Configuración de fondos
    const [fondos, setFondos] = useState([
        { id: 1, nombre: 'Fondo Emergencia', presupuesto: 2400000, activo: true },
        { id: 2, nombre: 'Fondo Inversión', presupuesto: 3000000, activo: true },
        { id: 3, nombre: 'Fondo Capitalización', presupuesto: 1200000, activo: true },
        { id: 4, nombre: 'Fondo Capacidad Laboral', presupuesto: 3000000, activo: true }
    ]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const abrirModal = (tipo, categoriaId = null) => {
        setModalType(tipo);
        setSelectedCategoria(categoriaId);
        setFormData({
            nombre: '',
            descripcion: '',
            color: '#000000',
            activo: true
        });
        setShowModal(true);
    };

    const guardarConfiguracion = () => {
        if (modalType === 'categoria') {
            // Agregar nueva categoría
            const nuevaCategoria = {
                id: Date.now(),
                ...formData,
                subcategorias: []
            };
            setCategorias(prev => [...prev, nuevaCategoria]);
        } else if (modalType === 'subcategoria') {
            // Agregar nueva subcategoría
            setCategorias(prev => prev.map(cat => {
                if (cat.id === selectedCategoria) {
                    return {
                        ...cat,
                        subcategorias: [...cat.subcategorias, {
                            id: Date.now(),
                            nombre: formData.nombre,
                            activo: formData.activo
                        }]
                    };
                }
                return cat;
            }));
        }
        setShowModal(false);
    };

    const toggleEstado = (categoriaId, subcategoriaId = null) => {
        if (subcategoriaId) {
            // Toggle subcategoría
            setCategorias(prev => prev.map(cat => {
                if (cat.id === categoriaId) {
                    return {
                        ...cat,
                        subcategorias: cat.subcategorias.map(sub => 
                            sub.id === subcategoriaId 
                                ? { ...sub, activo: !sub.activo }
                                : sub
                        )
                    };
                }
                return cat;
            }));
        } else {
            // Toggle categoría
            setCategorias(prev => prev.map(cat => 
                cat.id === categoriaId 
                    ? { ...cat, activo: !cat.activo }
                    : cat
            ));
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0
        }).format(amount);
    };

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Configuración de Gastos</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='/gastos' className="mc-breadcrumb-link">Gastos</Link></li>
                                <li className="mc-breadcrumb-item">Configuración</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                {/* Gestión de Categorías */}
                <Col xl={8}>
                    <Card className="mc-card">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5>Categorías y Subcategorías</h5>
                            <Button 
                                variant="primary" 
                                size="sm"
                                onClick={() => abrirModal('categoria')}
                            >
                                <i className="material-icons me-1">add</i>
                                Nueva Categoría
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            {categorias.map((categoria) => (
                                <div key={categoria.id} className="mb-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3 p-3 border rounded" 
                                         style={{ borderLeft: `4px solid ${categoria.color}` }}>
                                        <div>
                                            <h6 className="mb-1">{categoria.nombre}</h6>
                                            <small className="text-muted">{categoria.descripcion}</small>
                                        </div>
                                        <div>
                                            <Badge bg={categoria.activo ? "success" : "danger"} className="me-2">
                                                {categoria.activo ? "Activo" : "Inactivo"}
                                            </Badge>
                                            <Button 
                                                variant="outline-primary" 
                                                size="sm" 
                                                className="me-2"
                                                onClick={() => abrirModal('subcategoria', categoria.id)}
                                            >
                                                <i className="material-icons">add</i>
                                            </Button>
                                            <Button 
                                                variant="outline-secondary" 
                                                size="sm"
                                                onClick={() => toggleEstado(categoria.id)}
                                            >
                                                <i className="material-icons">
                                                    {categoria.activo ? 'toggle_on' : 'toggle_off'}
                                                </i>
                                            </Button>
                                        </div>
                                    </div>
                                    
                                    <Row className="ms-3">
                                        {categoria.subcategorias.map((subcategoria) => (
                                            <Col key={subcategoria.id} md={3} className="mb-2">
                                                <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light">
                                                    <span className={subcategoria.activo ? "" : "text-muted text-decoration-line-through"}>
                                                        {subcategoria.nombre}
                                                    </span>
                                                    <Button 
                                                        variant="link" 
                                                        size="sm" 
                                                        className="p-0"
                                                        onClick={() => toggleEstado(categoria.id, subcategoria.id)}
                                                    >
                                                        <i className="material-icons" style={{ fontSize: '16px' }}>
                                                            {subcategoria.activo ? 'toggle_on' : 'toggle_off'}
                                                        </i>
                                                    </Button>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Gestión de Fondos */}
                <Col xl={4}>
                    <Card className="mc-card">
                        <Card.Header>
                            <h5>Fondos Presupuestarios</h5>
                        </Card.Header>
                        <Card.Body>
                            {fondos.map((fondo) => (
                                <div key={fondo.id} className="mb-3 p-3 border rounded">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0">{fondo.nombre}</h6>
                                        <Badge bg={fondo.activo ? "success" : "danger"}>
                                            {fondo.activo ? "Activo" : "Inactivo"}
                                        </Badge>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Presupuesto:</span>
                                        <strong>{formatCurrency(fondo.presupuesto)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between mt-2">
                                        <Button variant="outline-primary" size="sm">
                                            Editar
                                        </Button>
                                        <Button 
                                            variant="outline-secondary" 
                                            size="sm"
                                            onClick={() => {
                                                setFondos(prev => prev.map(f => 
                                                    f.id === fondo.id 
                                                        ? { ...f, activo: !f.activo }
                                                        : f
                                                ));
                                            }}
                                        >
                                            {fondo.activo ? 'Desactivar' : 'Activar'}
                                        </Button>
                                    </div>
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Configuraciones generales */}
                <Col xl={12}>
                    <Card className="mc-card">
                        <Card.Header>
                            <h5>Configuraciones Generales</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check 
                                            type="checkbox" 
                                            label="Requerir aprobación para gastos > $100.000"
                                            defaultChecked
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check 
                                            type="checkbox" 
                                            label="Enviar alertas de presupuesto al 80%"
                                            defaultChecked
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check 
                                            type="checkbox" 
                                            label="Requerir documento adjunto obligatorio"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="text-end">
                                <Button variant="success">Guardar Configuración</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Modal para agregar categoría/subcategoría */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === 'categoria' ? 'Nueva Categoría' : 'Nueva Subcategoría'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre *</Form.Label>
                            <Form.Control
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                placeholder="Nombre de la categoría/subcategoría"
                                required
                            />
                        </Form.Group>
                        
                        {modalType === 'categoria' && (
                            <>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descripción</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="descripcion"
                                        value={formData.descripcion}
                                        onChange={handleInputChange}
                                        placeholder="Descripción de la categoría"
                                    />
                                </Form.Group>
                                
                                <Form.Group className="mb-3">
                                    <Form.Label>Color</Form.Label>
                                    <Form.Control
                                        type="color"
                                        name="color"
                                        value={formData.color}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </>
                        )}
                        
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                name="activo"
                                checked={formData.activo}
                                onChange={handleInputChange}
                                label="Activo"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={guardarConfiguracion}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
        </PageLayout>
    );
}
